import React from "react";
import { Redirect } from "react-router-dom";
import BackButton from "../ChildComponent/BackButton";
import COLORS from "../resources/colors/COLORS";
import "../css/Admin_css/admin-customize.css";

const TransportAttendance = () => {
  const loggedIn = localStorage.getItem("token") != null;

  if (!loggedIn) return <Redirect to="/Login" />;

  return (
    <div className="content" style={{ background: COLORS.whitesmoke }}>
      <div
        className="content-header d-flex justify-content-between align-items-center"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header d-flex align-items-center">
          <BackButton />
          <ul className="breadcrumbs mb-0">
            <li>
              <span style={{ color: COLORS.white }}>Transport Attendance</span>
            </li>
          </ul>
        </div>
      </div>

      <div
        className="bg_page_white_rounded box_shadow"
        style={{ padding: "16px 20px", margin: "16px" }}
      />
    </div>
  );
};

export default TransportAttendance;
